import type { ReactNode } from "react";

/**
 * A horizontally scrolling row of toggle chips. Each chip is a real
 * button, so D-pad focus walks the row left/right on TV.
 */
export function ChipRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div
      role="group"
      aria-label={label}
      className="flex gap-2 overflow-x-auto no-scrollbar -mx-3 px-3 py-1 tv:flex-wrap tv:overflow-visible"
    >
      {children}
    </div>
  );
}

export function Chip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={
        "shrink-0 whitespace-nowrap rounded-full border px-3 py-1 text-sm transition-colors " +
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent tv:text-base tv:px-4 tv:py-2 " +
        (active ? "bg-primary border-accent text-text" : "border-border text-text/70 hover:text-text hover:border-accent")
      }
    >
      {children}
    </button>
  );
}
